// No CMS field exists for this label (the ticket reuses the Wallet elements)
export function useNewScheduleLabel(): string {
  return "New schedule";
}
